import { Component, Inject, type OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { type ColDef } from 'ag-grid-community'
import { DefaultGridContextMenu } from 'src/app/05_ag-grid-configs/02_global-settings/grid-options'

export interface FullTableModalData {
  title: string
  columnDefs: ColDef[]
  rowData: any[]
}

@Component({
  standalone: false,
  selector: 'app-full-table-modal',
  templateUrl: './full-table-modal.component.html',
  styleUrls: ['./full-table-modal.component.scss']
})
export class FullTableModalComponent implements OnInit {
  closeModal!: () => void

  gridOptions = {
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100
    },
    domLayout: 'normal',
    suppressHorizontalScroll: false,
    getContextMenuItems: params => DefaultGridContextMenu(params)
  }

  constructor (
    public dialogRef: MatDialogRef<FullTableModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FullTableModalData
  ) {}

  ngOnInit (): void {}

  onClose (): void {
    if (this.closeModal) {
      this.closeModal()
    } else {
      this.dialogRef.close()
    }
  }
}
